import { StoreApi } from 'zustand';
import { EvaluationSlice } from './types';
import {
  fetchEvaluationList,
  fetchEvaluationDetail,
} from '../../../api/api';
import {
  FetchEvaluationListRequest,
  FetchEvaluationListResponse,
  FetchEvaluationDetailRequest,
  FetchEvaluationDetailResponse,
} from 'api-types';

export const createEvaluationSlice = (
  set: StoreApi<EvaluationSlice>['setState'],
  get: StoreApi<EvaluationSlice>['getState']
): EvaluationSlice => ({
  fetchEvaluationList: async (
    req: FetchEvaluationListRequest
  ): Promise<FetchEvaluationListResponse> => {
    return await fetchEvaluationList(req);
  },
  
  fetchEvaluationDetail: async (
    req: FetchEvaluationDetailRequest
  ): Promise<FetchEvaluationDetailResponse> => {
    return await fetchEvaluationDetail(req);
  },
});